import request from '@/utils/request'

export function getTradingStrategyPool ({
  tradeDate = '',
  layer = 3,
  streak = 0,
  symbol = '',
  pageNum = 1,
  pageSize = 10,
  sortField = 'amount',
  sortOrder = 'desc'
} = {}) {
  const params = {
    layer,
    streak,
    page_num: pageNum,
    page_size: pageSize,
    sort_field: sortField,
    sort_order: sortOrder
  }
  if (tradeDate) params.trade_date = tradeDate
  if (symbol) params.symbol = symbol

  return request({
    url: '/trading-strategy/pool',
    method: 'get',
    params,
    timeout: 60000
  })
}
